webpackJsonp([263791100135453],{

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamor = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = {
	  marginBottom: 0
	};
	
	var ImageCarousel = function (_React$Component) {
	  _inherits(ImageCarousel, _React$Component);
	
	  function ImageCarousel(props) {
	    _classCallCheck(this, ImageCarousel);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleAdvancePhoto = _this.handleAdvancePhoto.bind(_this);
	    _this.handleReversePhoto = _this.handleReversePhoto.bind(_this);
	    _this.state = {
	      photoNumber: 0,
	      portraitCarousel: ['https://storage.googleapis.com/russellmschmidt-net-portfolio/portraits/russell-portrait-1.jpg', 'https://storage.googleapis.com/russellmschmidt-net-portfolio/portraits/russell-portrait-2.jpg', 'https://storage.googleapis.com/russellmschmidt-net-portfolio/portraits/russell-portrait-3.jpg', 'https://storage.googleapis.com/russellmschmidt-net-portfolio/portraits/russell-portrait-4.jpg', 'https://storage.googleapis.com/russellmschmidt-net-portfolio/portraits/russell-portrait-5.jpg'],
	      captionCarousel: ['Photo courtesy of my wife and the iPhone CE, in an elevator', 'A portrait of me with my mother', 'My 137th and final space walk after repairing Hubble with a pair of pliers', 'Lobster shirt and fauxhawk, outfit of the consumate professional', 'Separated at birth']
	    };
	    return _this;
	  }
	
	  ImageCarousel.prototype.handleAdvancePhoto = function handleAdvancePhoto() {
	    if (this.state.photoNumber >= this.state.portraitCarousel.length - 1) {
	      this.setState(function () {
	        return {
	          photoNumber: 0
	        };
	      });
	    } else {
	      this.setState(function (prevState) {
	        return {
	          photoNumber: prevState.photoNumber + 1
	        };
	      });
	    }
	  };
	
	  ImageCarousel.prototype.handleReversePhoto = function handleReversePhoto() {
	    var _this2 = this;
	
	    if (this.state.photoNumber <= 0) {
	      this.setState(function () {
	        return {
	          photoNumber: _this2.state.portraitCarousel.length - 1
	        };
	      });
	    } else {
	      this.setState(function (prevState) {
	        return {
	          photoNumber: prevState.photoNumber - 1
	        };
	      });
	    }
	  };
	
	  ImageCarousel.prototype.render = function render() {
	    return Glamor.createElement(
	      'figure',
	      { css: _ref },
	      Glamor.createElement('img', { css: {
	          display: 'inline-block',
	          margin: '0 auto',
	          '@media (min-width: 768px)': {
	            padding: '0 25px 25px 0'
	          }
	        }, src: this.state.portraitCarousel[this.state.photoNumber] }),
	      Glamor.createElement(
	        'div',
	        { css: {
	            display: 'flex',
	            flexFlow: 'row nowrap',
	            justifyContent: 'space-between',
	            position: 'relative',
	            top: -50,
	            '@media (min-width: 768px)': {
	              top: -67
	            }
	          } },
	        Glamor.createElement(
	          'button',
	          { css: {
	              border: 'none',
	              background: 'rgba(200,200,200, 0.6)',
	              width: '40%',
	              cursor: 'pointer',
	              '@media (min-width: 768px)': {
	                width: '20%',
	                fontSize: 14,
	                marginLeft: 0
	              }
	            }, onClick: this.handleReversePhoto },
	          'Previous'
	        ),
	        Glamor.createElement(
	          'button',
	          { css: {
	              border: 'none',
	              background: 'rgba(200,200,200, 0.6)',
	              width: '40%',
	              cursor: 'pointer',
	              '@media (min-width: 768px)': {
	                width: '20%',
	                fontSize: 14,
	                marginRight: 25
	              }
	            }, onClick: this.handleAdvancePhoto },
	          'Next'
	        )
	      ),
	      Glamor.createElement(
	        'figcaption',
	        { css: {
	            minHeight: '3.2rem',
	            fontSize: '1rem',
	            lineHeight: 1.2,
	            marginTop: -35,
	            '@media (min-width: 768px)': {
	              marginTop: -55
	            }
	          } },
	        this.state.captionCarousel[this.state.photoNumber]
	      )
	    );
	  };
	
	  return ImageCarousel;
	}(_react2.default.Component);
	
	exports.default = ImageCarousel;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return Glamor.createElement(
	    "span",
	    null,
	    Glamor.createElement("img", { src: "https://storage.googleapis.com/russellmschmidt-net-portfolio/icons/medal-icons/icons8-bronze-medal-48.png", alt: "3rd place bronze medal" })
	  );
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return Glamor.createElement(
	    "span",
	    null,
	    Glamor.createElement("img", { src: "https://storage.googleapis.com/russellmschmidt-net-portfolio/icons/medal-icons/icons8-gold-medal-48.png", alt: "1st place gold medal" })
	  );
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return Glamor.createElement(
	    "span",
	    null,
	    Glamor.createElement("img", { src: "https://storage.googleapis.com/russellmschmidt-net-portfolio/icons/medal-icons/icons8-silver-medal-48.png", alt: "2nd place silver medal" })
	  );
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _glamorous = __webpack_require__(30);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _glamor = __webpack_require__(10);
	
	var _typography = __webpack_require__(28);
	
	var _MedalGold = __webpack_require__(263);
	
	var _MedalGold2 = _interopRequireDefault(_MedalGold);
	
	var _MedalSilver = __webpack_require__(264);
	
	var _MedalSilver2 = _interopRequireDefault(_MedalSilver);
	
	var _MedalBronze = __webpack_require__(262);
	
	var _MedalBronze2 = _interopRequireDefault(_MedalBronze);
	
	var _ImageCarousel = __webpack_require__(261);
	
	var _ImageCarousel2 = _interopRequireDefault(_ImageCarousel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var throb = _glamor.css.keyframes('throb', {
	  '0%': { borderBottom: '1px dotted #f92300' },
	  '7.7%': { borderBottom: '1px dotted #ff2100' },
	  '15.4%': { borderBottom: '1px dotted #ffa100' },
	  '23.1%': { borderBottom: '1px dotted #ddff00' },
	  '30.8%': { borderBottom: '1px dotted #5dff00' },
	  '38.5%': { borderBottom: '1px dotted #00ff21' },
	  '46.2%': { borderBottom: '1px dotted #00ffa1' },
	  '53.9%': { borderBottom: '1px dotted #00ddff' },
	  '61.6%': { borderBottom: '1px dotted #005dff' },
	  '69.3%': { borderBottom: '1px dotted #2200ff' },
	  '77%': { borderBottom: '1px dotted #a100ff' },
	  '84.7%': { borderBottom: '1px dotted #ff00dc' },
	  '92.4%': { borderBottom: '1px dotted #ff005d' },
	  '100%': { borderBottom: '1px dotted #f92300' }
	});
	
	var container = (0, _glamor.css)({
	  height: '100%',
	  ' ul': {
	    listStyleType: 'none',
	    listStylePosition: 'outside',
	    margin: '0 0 1rem 0'
	  },
	  ' li, a': {
	    margin: 0,
	    padding: 0
	  },
	  ' a': {
	    fontSize: 14,
	    '&:hover': {
	      textDecoration: 'none',
	      color: '#f92300',
	      fontWeight: 600,
	      animation: throb + ' 3s 1s ease-in-out infinite'
	    }
	  },
	  ' li': {
	    fontSize: 12
	  },
	  ' p': {
	    fontSize: 14,
	    width: '90%',
	    marginBottom: 10
	  },
	  ' span img': {
	    maxHeight: 14
	  },
	  ' h3': {
	    margin: '1rem 0'
	  },
	  ' h6': {
	    margin: '0.3rem 0',
	    fontStyle: 'normal'
	  },
	  ' figure>img': {
	    marginBottom: 5
	  },
	  ' figcaption': {
	    textAlign: 'center'
	  },
	  '@media (min-width: 768px)': {
	    ' h3': {
	      margin: '0 0 1rem 0'
	    },
	    ' h6': {
	      margin: '0 0 0.3rem 0',
	      fontStyle: 'normal'
	    },
	    ' li, a, p': {
	      fontSize: 12
	    },
	    ' span img': {
	      maxHeight: 12
	    },
	    ' figcaption': {
	      fontSize: 12
	    },
	    ' p': {
	      marginBottom: '1rem'
	    }
	  }
	});
	
	var innerContainer = (0, _glamor.css)({
	  display: 'grid',
	  gridTemplateColumns: 'repeat(12, 8%)',
	  gridTemplateRows: 'auto',
	  width: '100%',
	  minHeight: 'calc(100vh-300px)',
	  justifyContent: 'space-evenly',
	  '@media (max-width: 767px)': {
	    gridTemplateRows: '40% auto'
	  }
	});
	
	var imageContainer = (0, _glamor.css)({
	  gridColumn: 'span 12',
	  '@media (min-width: 768px)': {
	    gridColumn: 'span 6',
	    width: '90%'
	  }
	});
	
	var articleContainer = (0, _glamor.css)({
	  gridColumn: 'span 8',
	  '@media (min-width: 768px)': {
	    gridColumn: 'span 4',
	    width: '92%'
	  }
	});
	
	var sidenavContainer = (0, _glamor.css)({
	  gridColumn: 'span 4',
	  '@media (min-width: 768px)': {
	    gridColumn: 'span 2'
	  }
	});
	
	var AboutArticle = function AboutArticle() {
	  return Glamor.createElement(
	    'article',
	    null,
	    Glamor.createElement(
	      'h3',
	      null,
	      'Let\'s Make Something Cool'
	    ),
	    Glamor.createElement(
	      'p',
	      null,
	      'I am experienced in frontend and backend website development. ',
	      Glamor.createElement(
	        _gatsbyLink2.default,
	        { to: '/contact-me/' },
	        'Please reach out'
	      ),
	      ' if you need someone to help maintain your current website or want to build something new.'
	    ),
	    Glamor.createElement(
	      'p',
	      null,
	      'Not sure what architecture or language to use? I have a broad exposure to different architectures, having built and maintained websites using React, Ruby on Rails, WordPress & WooCommerce, Shopify, Squarespace, Jekyll, and Gatsby.'
	    ),
	    Glamor.createElement(
	      'p',
	      null,
	      'Not sure if I am a good fit? Me neither! But I\'ve worked with corporate and nonprofit organizations to help them meet their online goals, and am generally pretty agreeable. I hope we can create something together!'
	    )
	  );
	};
	
	var BioArticle = function BioArticle() {
	  return Glamor.createElement(
	    'article',
	    null,
	    Glamor.createElement(
	      'h3',
	      null,
	      'Biography'
	    ),
	    Glamor.createElement(
	      'p',
	      null,
	      'Hi visitor! Thanks for your interest in me, I am flattered. I hope to get to know you, too.'
	    ),
	    Glamor.createElement(
	      'p',
	      null,
	      'My work interests are making websites and native apps for you ',
	      Glamor.createElement(
	        _gatsbyLink2.default,
	        { to: '/about-me/' },
	        '(hit me up)'
	      ),
	      '! I love design and making sites.'
	    ),
	    Glamor.createElement(
	      'p',
	      null,
	      'When I am not dreaming about working with you in my spare time, which is rarely, I can be found: reading, playing with my dog-daughter (aka my DogTer\u2122) Violet, traveling, visiting museums and galleries, baseball, yoga, and having fun with my wife, in no particular order other than wife is first (hi, Janet!).'
	    ),
	    Glamor.createElement(
	      'p',
	      null,
	      'For media consumption, I enjoy binge watching science fiction, especially when set in dystopian hellscapes, and also historical dramas. I don\'t have a favorite music genre, but loud and fast is generally best.'
	    )
	  );
	};
	
	var EdArticle = function EdArticle() {
	  return Glamor.createElement(
	    'article',
	    null,
	    Glamor.createElement(
	      'h3',
	      null,
	      'Education'
	    ),
	    Glamor.createElement(
	      'ul',
	      null,
	      Glamor.createElement(
	        'li',
	        null,
	        Glamor.createElement(
	          'h6',
	          null,
	          'Master of Science in Integrated Design, Business and Technology'
	        ),
	        Glamor.createElement(
	          'ul',
	          null,
	          Glamor.createElement(
	            'li',
	            null,
	            'University of Southern California (USC)'
	          ),
	          Glamor.createElement(
	            'li',
	            null,
	            'Iovine and Young Academy'
	          ),
	          Glamor.createElement(
	            'li',
	            null,
	            '2019 (candidate)'
	          ),
	          Glamor.createElement(
	            'li',
	            null,
	            Glamor.createElement(
	              'a',
	              { href: 'https://design.usc.edu/about/', target: '_blank' },
	              'Design@USC'
	            )
	          )
	        )
	      ),
	      Glamor.createElement(
	        'li',
	        null,
	        Glamor.createElement(
	          'h6',
	          null,
	          'Bachelor of Arts in Economics'
	        ),
	        Glamor.createElement(
	          'ul',
	          null,
	          Glamor.createElement(
	            'li',
	            null,
	            'Harvard University'
	          ),
	          Glamor.createElement(
	            'li',
	            null,
	            '2001'
	          ),
	          Glamor.createElement(
	            'li',
	            null,
	            Glamor.createElement(
	              'a',
	              { href: 'https://economics.harvard.edu/', target: '_blank' },
	              'Economics Department'
	            )
	          )
	        )
	      ),
	      Glamor.createElement(
	        'li',
	        null,
	        Glamor.createElement(
	          'h6',
	          null,
	          'Software Engineering Apprenticeship'
	        ),
	        Glamor.createElement(
	          'ul',
	          null,
	          Glamor.createElement(
	            'li',
	            null,
	            'Bloc'
	          ),
	          Glamor.createElement(
	            'li',
	            null,
	            '2017'
	          ),
	          Glamor.createElement(
	            'li',
	            null,
	            Glamor.createElement(
	              'a',
	              { href: 'https://blog.bloc.io/announcing-software-engineering-track/', target: '_blank' },
	              'Software Engineering Track'
	            )
	          )
	        )
	      ),
	      Glamor.createElement(
	        'li',
	        null,
	        Glamor.createElement(
	          'h6',
	          null,
	          'Certificate in Mobile Development (iOS/Swift)'
	        ),
	        Glamor.createElement(
	          'ul',
	          null,
	          Glamor.createElement(
	            'li',
	            null,
	            'General Assembly'
	          ),
	          Glamor.createElement(
	            'li',
	            null,
	            '2015'
	          ),
	          Glamor.createElement(
	            'li',
	            null,
	            Glamor.createElement(
	              'a',
	              { href: 'https://generalassemb.ly/education/ios-development', target: '_blank' },
	              'iOS Development'
	            )
	          )
	        )
	      ),
	      Glamor.createElement(
	        'li',
	        null,
	        Glamor.createElement(
	          'h6',
	          null,
	          'Certificate in Entrepreneurship'
	        ),
	        Glamor.createElement(
	          'ul',
	          null,
	          Glamor.createElement(
	            'li',
	            null,
	            'Goldman Sachs\' 10,000 Small Businesses'
	          ),
	          Glamor.createElement(
	            'li',
	            null,
	            '2014'
	          ),
	          Glamor.createElement(
	            'li',
	            null,
	            Glamor.createElement(
	              'a',
	              { href: 'http://www.goldmansachs.com/citizenship/10000-small-businesses/US/', target: '_blank' },
	              'GS10KSB'
	            )
	          )
	        )
	      ),
	      Glamor.createElement(
	        'li',
	        null,
	        Glamor.createElement(
	          'h6',
	          null,
	          'Certificate in Digital Marketing'
	        ),
	        Glamor.createElement(
	          'ul',
	          null,
	          Glamor.createElement(
	            'li',
	            null,
	            'General Assembly'
	          ),
	          Glamor.createElement(
	            'li',
	            null,
	            '2013'
	          ),
	          Glamor.createElement(
	            'li',
	            null,
	            Glamor.createElement(
	              'a',
	              { href: 'https://generalassemb.ly/education/digital-marketing', target: '_blank' },
	              'Digital Marketing & Strategy'
	            )
	          )
	        )
	      ),
	      Glamor.createElement(
	        'li',
	        null,
	        Glamor.createElement(
	          'h6',
	          null,
	          'Back-End Web Development'
	        ),
	        Glamor.createElement(
	          'ul',
	          null,
	          Glamor.createElement(
	            'li',
	            null,
	            'General Assembly'
	          ),
	          Glamor.createElement(
	            'li',
	            null,
	            '2012'
	          ),
	          Glamor.createElement(
	            'li',
	            null,
	            Glamor.createElement(
	              'a',
	              { href: 'https://generalassemb.ly/education/back-end-web-development', target: '_blank' },
	              'Back-End Web Development'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var ResumeList = function ResumeList() {
	  return Glamor.createElement(
	    'ul',
	    null,
	    Glamor.createElement(
	      'li',
	      null,
	      Glamor.createElement(
	        'a',
	        { href: 'https://storage.googleapis.com/russellmschmidt-net-portfolio/resume/Schmidt_Russell__Resume.pdf', target: '_blank' },
	        'Resume'
	      )
	    )
	  );
	};
	
	var LanguagesList = function LanguagesList() {
	  return Glamor.createElement(
	    'ul',
	    null,
	    Glamor.createElement(
	      'li',
	      null,
	      'Angular v1 ',
	      Glamor.createElement(_MedalBronze2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'CSS ',
	      Glamor.createElement(_MedalGold2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'Gatsby ',
	      Glamor.createElement(_MedalSilver2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'HTML ',
	      Glamor.createElement(_MedalGold2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'JavaScript ',
	      Glamor.createElement(_MedalGold2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'Jekyll ',
	      Glamor.createElement(_MedalBronze2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'jQuery ',
	      Glamor.createElement(_MedalSilver2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'Meteor ',
	      Glamor.createElement(_MedalBronze2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'PHP ',
	      Glamor.createElement(_MedalBronze2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'React ',
	      Glamor.createElement(_MedalSilver2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'React Native ',
	      Glamor.createElement(_MedalBronze2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'Ruby ',
	      Glamor.createElement(_MedalSilver2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'Ruby on Rails ',
	      Glamor.createElement(_MedalSilver2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'SASS/SCSS ',
	      Glamor.createElement(_MedalGold2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'Shopify ',
	      Glamor.createElement(_MedalGold2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'Squarespace ',
	      Glamor.createElement(_MedalGold2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'Swift ',
	      Glamor.createElement(_MedalBronze2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'WooCommerce ',
	      Glamor.createElement(_MedalSilver2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'WordPress ',
	      Glamor.createElement(_MedalGold2.default, null)
	    )
	  );
	};
	
	var DatabasesList = function DatabasesList() {
	  return Glamor.createElement(
	    'ul',
	    null,
	    Glamor.createElement(
	      'li',
	      null,
	      'Firebase ',
	      Glamor.createElement(_MedalBronze2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'GraphQL ',
	      Glamor.createElement(_MedalBronze2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'MongoDB ',
	      Glamor.createElement(_MedalBronze2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'PostgreSQL ',
	      Glamor.createElement(_MedalSilver2.default, null)
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      'SQL ',
	      Glamor.createElement(_MedalSilver2.default, null)
	    )
	  );
	};
	
	var OpenSourceContributionsList = function OpenSourceContributionsList() {
	  return Glamor.createElement(
	    'ul',
	    null,
	    Glamor.createElement(
	      'li',
	      null,
	      Glamor.createElement(
	        'a',
	        { href: 'https://github.com/stympy/faker', target: '_blank' },
	        'Faker'
	      )
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      Glamor.createElement(
	        'a',
	        { href: 'https://github.com/botpress/botpress/pull/177', target: '_blank' },
	        'Botpress'
	      )
	    ),
	    Glamor.createElement(
	      'li',
	      null,
	      Glamor.createElement(
	        'a',
	        { href: 'https://github.com/andrewngu/sound-redux/pull/99', target: '_blank' },
	        'SoundRedux'
	      )
	    )
	  );
	};
	
	var OpenSourceProjectsList = function OpenSourceProjectsList() {
	  return Glamor.createElement(
	    'ul',
	    null,
	    Glamor.createElement(
	      'li',
	      null,
	      Glamor.createElement(
	        'a',
	        { href: 'https://github.com/russellschmidt/climate-cents', target: '_blank' },
	        'Ruby on Rails Crowdfunding'
	      )
	    )
	  );
	};
	
	var CreditsList = function CreditsList() {
	  return Glamor.createElement(
	    'ul',
	    null,
	    Glamor.createElement(
	      'li',
	      null,
	      'Icons sourced from ',
	      Glamor.createElement(
	        'a',
	        { href: 'https://icons8.com/', target: '_blank' },
	        'icons8.com'
	      )
	    )
	  );
	};
	
	exports.default = function () {
	  return Glamor.createElement(
	    'div',
	    { className: container },
	    Glamor.createElement(_reactHelmet2.default, { title: 'About Russell Schmidt, a developer in Los Angeles, CA' }),
	    Glamor.createElement(
	      'h1',
	      null,
	      'About'
	    ),
	    Glamor.createElement(
	      'div',
	      { className: innerContainer },
	      Glamor.createElement(
	        'div',
	        { className: imageContainer },
	        Glamor.createElement(_ImageCarousel2.default, null),
	        Glamor.createElement(AboutArticle, null)
	      ),
	      Glamor.createElement(
	        'div',
	        { className: articleContainer },
	        Glamor.createElement(BioArticle, null),
	        Glamor.createElement(EdArticle, null)
	      ),
	      Glamor.createElement(
	        'div',
	        { className: sidenavContainer },
	        Glamor.createElement(
	          'h3',
	          null,
	          'Links'
	        ),
	        Glamor.createElement(
	          'h6',
	          null,
	          'CV'
	        ),
	        Glamor.createElement(ResumeList, null),
	        Glamor.createElement(
	          'h6',
	          null,
	          'Languages & Frameworks'
	        ),
	        Glamor.createElement(LanguagesList, null),
	        Glamor.createElement(
	          'h6',
	          null,
	          'Databases & Backend'
	        ),
	        Glamor.createElement(DatabasesList, null),
	        Glamor.createElement(
	          'h6',
	          null,
	          'Open Source Contributions'
	        ),
	        Glamor.createElement(OpenSourceContributionsList, null),
	        Glamor.createElement(
	          'h6',
	          null,
	          'Open Source Projects'
	        ),
	        Glamor.createElement(OpenSourceProjectsList, null),
	        Glamor.createElement(
	          'h6',
	          null,
	          'Icons'
	        ),
	        Glamor.createElement(CreditsList, null)
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-bd878cd209d1a3fe42fd.js